import { Star } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/components/ui/button'

interface RecommendOfferButtonProps {
  recommended: boolean
  /** Who put it forward, from the offer's brokerRecommendedByName. */
  recommendedByName: string | null
  onToggle: (recommended: boolean) => Promise<void>
  className?: string
}

/** Puts one offer forward as the broker's recommendation on the customer's Quotes Page. */
export function RecommendOfferButton({
  recommended,
  recommendedByName,
  onToggle,
  className,
}: RecommendOfferButtonProps) {
  const [isSaving, setIsSaving] = useState(false)

  const handleClick = async () => {
    setIsSaving(true)
    try {
      await onToggle(!recommended)
    } finally {
      setIsSaving(false)
    }
  }

  const recommendedLabel = recommendedByName ? `Recommended by ${recommendedByName}` : 'Recommended'

  return (
    <Button
      variant={recommended ? 'default' : 'outline'}
      size="sm"
      className={className}
      loading={isSaving ? 'Saving...' : undefined}
      onClick={handleClick}
    >
      <Star className={recommended ? 'fill-current' : undefined} />
      {recommended ? recommendedLabel : 'Recommend this quote'}
    </Button>
  )
}
